import styled from 'styled-components'

export const Grid = styled.div`
  padding: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
`
